"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _helpers = require("../../../utils/helpers");
var _TextSlideModule = _interopRequireDefault(require("./../../../scss/slide-layouts/TextSlide.module.scss"));
function TextSlide({
  text = '',
  backgroundColor = '#fff',
  textColor = '#444',
  fontSize = '2.4rem'
}) {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: _TextSlideModule.default['text-slide']
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _helpers.classes)([_TextSlideModule.default['text-slide__text'], 'text-slide__text']),
    style: {
      backgroundColor,
      color: textColor,
      fontSize
    }
  }, text));
}
var _default = exports.default = TextSlide;